import { useTranslation } from "react-i18next";
import "./TopBar.css";

const TopBar = () => {

  const { i18n } = useTranslation();

  return (
    <div className="topbar">
      <div className="topbar-container">

        <div className="topbar-left">

          <a href="tel:+917066883322" className="topbar-item">
            <i className="fa-solid fa-phone"></i>
            <span>+91 7066883322</span>
          </a>

          <a href="mailto:maanavtahitaay2026@gmail.com" className="topbar-item">
            <i className="fa-solid fa-envelope"></i>
            <span>maanavtahitaay2026@gmail.com</span>
          </a>

        </div>

        <div className="topbar-right">

          <div className="topbar-social">
            <a href="https://www.facebook.com/share/1AWhuCQVzH/"><i className="fa-brands fa-facebook-f"></i></a>
            <a href="https://www.instagram.com/maanavta_hitay?igsh=MXc1N3dkY2Z2b2g3ZA%3D%3D"><i className="fa-brands fa-instagram"></i></a>
            <a href="https://youtube.com/@manavtahitay-ek8hv"><i className="fa-brands fa-youtube"></i></a>
            <a href="https://wa.me/917066883322"><i className="fa-brands fa-whatsapp"></i></a>
          </div>

          <select
            className="topbar-language"
            onChange={(e) => i18n.changeLanguage(e.target.value)}
            defaultValue="en"
          >
            <option value="en">English</option>
            <option value="hi">Hindi</option>
            <option value="mr">Marathi</option>
          </select>

        </div>

      </div>
    </div>
  );
};

export default TopBar;